import * as constants from "./constants";

export const saveTokens = ({ accessToken, refreshToken }) => ({
  type: constants.SAVE_TOKENS,
  accessToken,
  refreshToken,
});
